import toString from 'lodash/toString';

import { IProductExcel } from '../../types';

/**
 * A row's `_savedData` is latched once at step-4 entry by matching the row's
 * EAN against an existing product. If the user later edits the EAN — e.g.
 * re-testing an existing article under a fresh code — that latch still points
 * at the old product, which is no longer this row. Callers use this to decide
 * whether saved-product fields should still be applied. EANs are normalised
 * via `toString` so a number/string mismatch doesn't read as a difference.
 */
export const savedDataMatchesEan = (data: IProductExcel): boolean => {
  if (!data._savedData) return false;
  return toString(data._savedData.EAN) === toString(data.EAN);
};
